/* eslint-disable */

import axios from 'axios';
import { answerKey } from '../../../client/src/stores/form_result';

const tabId = sessionStorage.tabID ? sessionStorage.tabID : sessionStorage.tabID = Math.random().toString();
const blocking = 15 * 60;

const SIGNAL_SOURCE = "channel"
export {SIGNAL_SOURCE}

const setup = (form_result_uid, formResultStore)=>{
    window.FormResultChannel = consumer.subscriptions.create(
        { channel: "FormResultChannel", room: `form_result__${form_result_uid}` },
        {
            connected(a) {
                this.formResultStore = formResultStore
                // Called when the subscription is ready for use on the server
                console.log(`FormResultChannel connected. My tab: ${tabId}`)
                this.send({message: 'who_what_blocking', from: tabId})
            },

            disconnected() {
                console.log(`!!!!disconnected`)
                // alert("We lost connection from server. Please refresh the page.")
                // Called when the subscription has been terminated by the server
            },

            currentFieldId(){
                return document.activeElement && document.activeElement.dataset.fieldId
            },

            sendBlockingMsg(field_id){
                this.send({ message: 'im_blocking', from: tabId, data: {tabId: tabId, time: getExpTime(), field_id: field_id } })
            },
            sendUnblockingMsg(field_id) {
                this.send({message: 'im_unblocking', from: tabId, data: {tabId: tabId, time: getExpTime(), field_id: field_id }})
            },
            sendChangedValueMsg(field_id, value) {
                this.send({message: 'changed_value', from: tabId, data: {tabId: tabId, value: value, field_id: field_id }})
            },
            sendChangedIdMsg(field_id, id, checked) {
                const payload = {tabId: tabId, value: id, checked, field_id: field_id }
                console.log("sending", payload)
                this.send({message: 'changed_id', from: tabId, data: payload})
            },

            managingFields(data){
                return document.querySelectorAll(`[data-field-id='${data.data.field_id}']`)
            },
            managingFieldsBlock(data){
                // field_id can come with id (from field itself) but block is always by field id
                const field_id = data.data.field_id.split('__')[0]
                return document.querySelectorAll(`[data-block-field-id^='${field_id}__']`)
            },

            received(data) {
                if (data.from === tabId) return

                // Called when there's incoming  data on the websocket for this channel
                console.log(`FormResultChannel received. My tab: ${tabId}. Data:`, data)
                switch (data.message) {
                    case 'who_what_blocking':
                        if (this.currentFieldId()) this.sendBlockingMsg(this.currentFieldId())
                        break;
                    case 'im_blocking':
                        console.log("we have blocked smth from:", data.from)

                        this.managingFields(data).forEach(node=> disableNode(node, data))
                        this.managingFieldsBlock(data).forEach(node=>node.querySelector('.overflow').classList.remove('hidden'))
                        break;
                    case 'im_unblocking':
                        console.log("we have unblocked smth from:", data.from)
                        this.managingFields(data).forEach(reEnableNode)
                        this.managingFieldsBlock(data).forEach(node=> node.querySelector('.overflow').classList.add('hidden'))
                        break;
                    case 'changed_value':
                        console.log('Value changed:', data.data.value, data)
                        const answer = data.data.value
                        formResultStore.addAnswer(answer, SIGNAL_SOURCE)
                        break;
                    case 'changed_id':
                        const {field_id, value, checked} = data.data
                        console.log('Id changed:',field_id, value,checked, data)
                        if (window.formResultAnswers && window.formResultAnswers[field_id]){
                            window.formResultAnswers[field_id].answer.id=value
                            window.formResultAnswers[field_id].answer.checked=checked
                        }
                        const answer2 = formResultStore.answersDict[field_id]
                        answer2.id      = value
                        answer2.checked = checked

                        break;
                }
            },
        }
    );
    defineTimeouts()

}

const unixTime = ()=> new Date().getTime()/1000
const getExpTime = ()=> unixTime() + blocking

const reEnableNode = (node)=>{
    node.disabled = false;
    delete node.disablingExpiresAt
    delete node.disabledBy
}

const disableNode = (node, data) => {
    node.disabled = true;
    node.disablingExpiresAt = data.data.time
    node.disabledBy = data.from
}



const defineTimeouts = ()=>{
    setInterval(()=>{
        document.querySelectorAll(`[data-field-id]:disabled`).forEach(node=>{
            if (unixTime() >= node.disablingExpiresAt) reEnableNode(node)
        })
    }, blocking * 1000)
}

const leavingPageDestruction = ()=>{
    console.log('hopefully destroyed');
    if (!window.FormResultChannel) return
    window.FormResultChannel.sendUnblockingMsg(window.FormResultChannel.currentFieldId())
    window.FormResultChannel.consumer.disconnect()
    window.FormResultChannel = undefined
}

const cacheAngularAnswers = (ctrl)=>{
    window.formResultAnswers || (window.formResultAnswers={})
    window.formResultAnswers[answerKey(ctrl)] = ctrl
}


// FIRST PART logic
const handleFocusOnChange = (ctrl, $routeParams, answers)=>{
    if (!window.FormResultChannel) return
    answers ||= [ctrl.answer]
    handleFocus(ctrl, $routeParams, answers)
    ctrl.focusTimeout && clearTimeout(ctrl.focusTimeout)
    ctrl.focusTimeout = setTimeout(_=>{
        saveChangesToDB($routeParams, answers)
        clearTimeout(ctrl.focusTimeout)
    }, blocking * 1000)
}

const handleFocus = (ctrl, $routeParams, answers)=>{
    if (!window.FormResultChannel) return
    answers ||= [ctrl.answer]
    console.log("handleFocus", answers)
    window.FormResultChannel.sendBlockingMsg(answerKey(answers[0]))
}

const handleFocusOut = (ctrl, $routeParams, answers)=> {
    if (!window.FormResultChannel) return
    answers ||= [ctrl.answer]
    console.log("handleFocusOut", answers)
    window.FormResultChannel.sendUnblockingMsg(answerKey(answers[0]))
    saveChangesToDB($routeParams, answers)
    ctrl.focusTimeout && clearTimeout(ctrl.focusTimeout)
}

const saveChangesToDB = ($routeParams, dirtyAnswers)=>{
    const formUid = $routeParams.form_uid || $routeParams.uid
    const contUid = $routeParams.contact_uid
    const url     = `/forms/${formUid}/form_results/${$routeParams.form_result_uid}`
    const answers = dirtyAnswers.filter(a=> a.data || a.upload_base64)
    console.log("answers", answers)
    if (!answers.length) return // checkbox do not update value on focusout

    if ($routeParams.form_result_uid) axios.put(url, {form_result_answers: answers, parallel: true}).then((resp)=>{
        // if we save new form_result_answer then we add id and send to other clients
        if (answers.length)
            axios.get(url, {
                params: {contact_id: contUid},
                headers: {Accept: 'application/json'}
            }).
            then(resp=>{
                for (const formAnswer of answers) {
                    const key = answerKey(formAnswer)
                    const newAnswer = resp.data.form_result_answers.find(fra => answerKey(fra) === key)
                    const newId = newAnswer?.id
                    const newChecked  = newAnswer?.checked

                    formAnswer.id = newId
                    window.FormResultChannel.sendChangedIdMsg(key, newId, newChecked)
                    console.log("new ID:", key, newId)
                }
            })

    }).catch(err=>console.error(err))

    // "|| ''" is because textarea and input can send undefined
    if (window.FormResultChannel){
        for (const answer of answers) {
            window.FormResultChannel.sendChangedValueMsg(answer.field_id, answer)
        }
    }
}
// FIRST PART logic end

export {
    setup,
    leavingPageDestruction,
    cacheAngularAnswers,
    handleFocusOnChange,
    handleFocus,
    handleFocusOut,
}
